module.exports = __webpack_public_path__ + "img/1x.a44ee3e.jpg";